import { WordItemData } from "ap-exerciser-sdk/models";

export class VocabWord {
  id: string;
  word: string;
  words: string[];
  phrase: string;
  label: string;

  constructor(wordData: { id: string, word: string, words: string[], phrase: string, label: string } | WordItemData) {
    if ("data" in wordData) {
      this.id = wordData.id;
      this.word = wordData.data.word.iv;
      this.words = wordData.data.words.iv?.map(word => {
        return word.word.iv;
      }) ?? [];
      this.phrase = wordData.data.phrase.iv ?? "";
      this.label = `${wordData.data.word.iv}` +
        (wordData.data.words.iv && wordData.data.words.iv.length > 0 ?
          wordData.data.words.iv.map((item) => ` / ${item.word}`) :
          "");
    } else {
      this.id = wordData.id;
      this.word = wordData.word;
      this.words = wordData.words;
      this.phrase = wordData.phrase;
      this.label = wordData.label;
    }
  }
}

export class VocabScenario {
  id: string;
  name: string;
  wordsList: VocabWord[];
  tags: string[];
  author: string;

  constructor(scenarioData: { id: string, name: string, wordsList: VocabWord[], tags: string[], author?: string }) {
    this.id = scenarioData.id;
    this.wordsList = scenarioData.wordsList;
    this.name = scenarioData.name;
    this.tags = scenarioData.tags;
    this.author = scenarioData.author ?? "";
  }
}